import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { IconChevronDown, IconChevronUp } from '../Icon';
import { LinkButton } from '../LinkButton';
import { Action, Body, Details, Wrapper } from './wrapper';

interface DetailBoxProps {
  children: React.ReactNode;
  details: React.ReactNode;
  buttonTextDefault?: string;
  buttonTextExtended?: string;
  openDefault?: boolean;
  onClick?: (open: boolean) => void;
}

const DetailBox = ({
  children,
  details,
  buttonTextDefault,
  buttonTextExtended,
  openDefault,
  onClick,
}: DetailBoxProps) => {
  const { t } = useTranslation(['common']);
  const [extend, setExtend] = useState(openDefault ? openDefault : false);
  const onToggleExtend = useCallback(() => {
    if (onClick) {
      onClick(!extend);
    }
    setExtend(!extend);
  }, [extend]);

  return (
    <Wrapper>
      <Body>{children}</Body>
      {extend && <Details>{details}</Details>}
      <Action>
        <LinkButton
          onClick={onToggleExtend}
          title={
            extend
              ? buttonTextExtended || t('showLess', { ns: 'common' })
              : buttonTextDefault || t('showMore', { ns: 'common' })
          }
          $hoverGhost
        >
          {extend ? buttonTextExtended : buttonTextDefault}
          {extend ? <IconChevronUp /> : <IconChevronDown />}
        </LinkButton>
      </Action>
    </Wrapper>
  );
};

export default DetailBox;
